import React from 'react';
import {
  Stack,
  Typography
} from '@mui/material';

interface ContactFormProps {
  textSize?: number;
}

export default function ContactForm({ textSize = 1 }: ContactFormProps) {

  return (
    <Stack spacing={3} sx={{ maxWidth: '600px', margin: '0 auto', padding: 2 }}>
      <Typography
        fontFamily="Playfair Display"
        fontSize={`${2 * textSize}vw`}
        color="text.primary"
        sx={{ textAlign: 'center' }}
      >
        Contact
      </Typography>

      <Typography
        fontFamily="Bitter"
        fontSize={`${Math.min(2 * textSize, 2.5)}vw`}
        color="text.primary"
        sx={{ textAlign: 'center' }}
      >
        shabnam.jabeen.studio@gmail.com
      </Typography>
    </Stack>
  );
}